import { AccordionBarChart } from '@/components/administration/kpi-metrics/shared/accordion-bar-chart'
import type { CommitmentMatrixDashboardBranchBreakdown } from '@/types'
import { formatPercentage } from '@/utils/format-percentage'

interface BranchBreakdownCardProps {
	branchBreakdown: CommitmentMatrixDashboardBranchBreakdown[]
}

export function BranchBreakdownCard({
	branchBreakdown,
}: BranchBreakdownCardProps) {
	return (
		<div className="rounded-lg border border-kaefer-light-silver bg-white p-4">
			<div className="flex items-baseline justify-between gap-2">
				<span className="text-sm font-semibold text-kaefer-dark-grey">
					Aderência por filial
				</span>
				<span className="text-[11px] text-muted-foreground">
					Detalhe por CR dentro de cada filial
				</span>
			</div>

			<AccordionBarChart
				items={branchBreakdown.map((branch) => ({
					id: branch.branchId,
					label: branch.branchName,
					value: branch.adherencePct,
					tooltip: (
						<BreakdownTooltipContent
							name={branch.branchName}
							done={branch.done}
							target={branch.target}
							adherencePct={branch.adherencePct}
						/>
					),
					children: branch.crBreakdown,
				}))}
				getChildId={(cr) => cr.crId}
				getChildLabel={(cr) => cr.crName}
				getChildValue={(cr) => cr.adherencePct}
				getChildTooltip={(cr) => (
					<BreakdownTooltipContent
						name={cr.crName}
						done={cr.done}
						target={cr.target}
						adherencePct={cr.adherencePct}
					/>
				)}
				emptyState={
					<p className="py-10 text-center text-sm text-muted-foreground">
						Sem dados suficientes para exibir o gráfico.
					</p>
				}
			/>
		</div>
	)
}

function BreakdownTooltipContent({
	name,
	done,
	target,
	adherencePct,
}: {
	name: string
	done: number
	target: number
	adherencePct: number
}) {
	return (
		<div className="flex flex-col gap-1 text-left">
			<p className="font-semibold text-kaefer-dark-grey">{name}</p>
			<p>
				<span className="text-muted-foreground">Progresso:</span> {done}/
				{target} ({formatPercentage(adherencePct)})
			</p>
		</div>
	)
}
